module.exports = __webpack_public_path__ + "img/security.2ab67820.svg";